import { getFormatDynamicRoute } from "./helpers";

// Note: routes are defined WITHOUT /game/ prefix. The prefix is applied by
// React Router's `basename` option (set to "/game" on in-touch.space, ""
// on wepurplay.com / wepurplay.ru) so URLs are clean on the new domains
// while in-touch.space keeps its existing /game/* paths.

const ROUTES = {
  APP_PAGE: "/app",
  SUPPORT_PAGE: "/support",
  PWA_INSTRUCTIONS_PAGE: "/pwa_instructions",
  LEAVE_REVIEW_PAGE: "/leave-review",
  FEEDBACK_PAGE: "/feedback",
  LOGIN_PAGE: "/login",
  RECOVERY_PAGE: "/login/recovery",
  RECOVERY_CODE_PAGE: "/login/recovery/code",
  NEW_PASSWORD_PAGE: "/login/recovery/code/new-pass",
  REGISTER_PAGE: "/register",
  REGISTER_AFTER_DEMO_PAGE: "/register-after-demo",
  EMAIL_CONFIRM_PAGE: "/register/confirmation",
  PAYMENT_INVITE_PAGE: "/payment/invite",
  RULES_PAGE: "/rules",
  ACCEPT_RULES_PAGE: "/accept-rules",
  MANUAL_PAGE: "/manual",
  MEET_PAGE: "/meet",
  EXTENDED_57_INSTRUCTION_PAGE: "/extended-57-instruction",
  IN_GAME_PAGE: "/in-game",
  END_GAME_PAGE: "/end-game",
  GREETINGS_PAGE: "/greetings",
  MATCHES_PAGE: "/matches",
  PAYMENT_PAGE: "/payment",
  // 30.10: возврат со страницы PayPlus, status: success | failure | cancel, order: номер заказа
  PAYMENT_RESULT_PAGE: "/payment-result/:status/:order?",
  PERSONAL_ACCOUNT_PAGE: "/personal-account",
  PERSONAL_ACCOUNT_EDIT_PAGE: "/personal-account/edit",
  GAME_FORMAT_PAGE: "/format",
  PRIVACY_PAYPLUS_PAGE: "/privacy-payplus",
  PRIVACY_PAGE: "/privacy",
  CONDITIONS_PAYPLUS_PAGE: "/conditions-payplus",
  CONDITIONS_PAGE: "/conditions",
  LANDING_PAGE: "/",
  GAME_ADS_PAGE: "/gameads",
  INSIGHT_DESCRIPTION: "/insight-description",
  INSIGHT_RECOMMENDATION: (id) =>
    `/insight-questionnaire/${id}/recommendation`,
  INSIGHT_RECOMMENDATION_PAIR: "/insight-recommendation/pair",
  INSIGHT_INSTRUCTION: "/insight-instruction",
  INSIGHT_QUESTIONNAIRE_PAGE: "/insight-questionnaire",
  INSIGHT_QUESTIONNAIRE_FORM_PAGE: (id) =>
    getFormatDynamicRoute(id, "/insight-questionnaire/"),
  HISTORY_INSIGHT_QUESTIONNAIRE_FORM_PAGE: (id) =>
    getFormatDynamicRoute(id, "/insight-questionnaire/history/"),
  COMPATIBILITY_SHARE_PAGE: "/compatibility-share",
  INSIGHT_INSIGHT_PICK_CARDS_PAGE: "/insight-pick-cards",
  DEMO_RESULT_PAGE: "/demo-result-page",
  IN_GAME_EDIT: "/in-game/edit",
  LINK_WAS_NOT_SENT_PAGE: "/link-was-not-sent",
};

export default ROUTES;
